import React from 'react'

import { ExpenseColumns, ExpenseData } from './ExpenseData'

import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader'
import DataTable from '../../../../../Common/DataTable/DataTable'
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter'

const ExpenseTable = () => {
    const dataT = ExpenseData.map((data) => {
        return {
            date: data.date,
            description: data.description,
            bank: data.bank,
            accountNumber: data.accountNumber,
            expenseAmount: data.expenseAmount,
            category: data.category,
            details: data.details,
            notes: data.notes
        };
    });

    return (
        <div>
            <DataTableHeader />
            <DataTable columns={ExpenseColumns} data={dataT} />
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default ExpenseTable